export default __webpack_public_path__ + "static/media/button_upload_en.1e65db27.svg";